<template>
  <div>
    <van-collapse v-model="activeNames">
      <van-collapse-item title="退换货规则" name="1">
        一、实物商品退换货 <br/><br/>
        (1)订单一经生成后若无商品质量问题，不予办理取消订单或商品退换货服务。<br/>
(2)换货仅限于更换同款式、同型号的商品，配送地址不可变更（变更地址产生物流费用需自行承担）。<br/>
(3)签收商品后，如果商品出现质量问题应立即停止使用。自商品签收之日起30日内，若存在质量问题可通过“我的订单-售后服务”提交换货申请；也可联系海尔积分商城客服或商品售后服务电话（相应产品页面有展示）处理，如有逾期积分商城将不予受理，敬请谅解。<br/>
(4)如出现以下情况则不予进行退换货：<br/>
1.因商品非正常使用出现质量问题；<br/>
2.因未经授权的修理、误用、疏忽、滥用、事故、改动及不正确的安装造成损坏；<br/>
3.将商品存储、暴露在不适宜商品存放的环境中造成损坏的；<br/>
4.商品的正常磨损；<br/>
5.已超出验货时限、非质量问题的商品；<br/>
6.在退换货之前未与客服取得联系；<br/>
7.任何非海尔积分商城兑换的商品；<br/>
8.商品图片及文字仅供参考，因拍摄灯光及不同显示器色差等问题可能造成图片与实物有色差，不属质量问题，具体以实物为准。<br/><br/>
        二、虚拟商品退换货<br/><br/>
        因虚拟商品特性，兑换成功不支持退换货处理，如在使用中遇到问题，请联系商品详情页下方售后服务电话咨询。
      </van-collapse-item>
      <van-collapse-item title="售后联系方式" name="2">
        <p>
          自积分订单签收之日起30日内，如遇任何关于积分商城商品或订单问题，您可通过联系“积分商城在线客服，电话客服：4006999999，或商品详情页下方售后电话”进行问题咨询反馈，逾期投诉积分商城将不予受理，给您带来的不便敬请谅解 。
        </p>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { sysNotice } from "@/api/api";
export default {
  data() {
    return {
      list: [],
      activeNames: [],
    };
  },
  methods: {
    
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.text {
  padding-top: 50px;
}
/deep/.blue {
  color: #2283e2 !important;
}
.contai {
  background: #fff;
  // border: 1px solid #2283e2;
  padding: 20px;
}

.header {
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #2283e2;
}

.paging {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.title {
  font-size: 25px;
  cursor: pointer;
}

.title:hover {
  color: #2283e2;
}
</style>
